/* Touch stamp: replays the card hover (slight zoom) once on devices without
   hover, when the card centers. One-shot per card, additive. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  // Touch and allowed motion only.
  if (!window.matchMedia('(hover: none)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var STAMP = 'bq-stamped';

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        io.unobserve(card);
        card.classList.add(STAMP);
        // Remove the class once the animation has played: the resting state
        // returns to neutral (the stamp does not stick).
        setTimeout(function () {
          card.classList.remove(STAMP);
        }, 1000);
      });
    },
    // Fires when the card is well into view (center near the field).
    { threshold: 0.55, rootMargin: '0px 0px -8% 0px' }
  );

  function scan(root) {
    var cards = (root || document).querySelectorAll('.bq-card:not([data-placeholder])');
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].dataset.bqStampSeen) {
        cards[i].dataset.bqStampSeen = '1';
        io.observe(cards[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Cards injected later (predictive search, cart suggestions, morphs): handled
  // as soon as they appear.
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('bq-card')) {
          scan(node.parentNode);
        } else if (node.querySelector && node.querySelector('.bq-card')) {
          scan(node);
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
